/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * This signifies what the number in the \'durationAmount\' field is.
 * @export
 * @enum {string}
 */
export enum DurationUnit {
    HOUR = 'HOUR',
    DAY = 'DAY'
}

export function DurationUnitFromJSON(json: any): DurationUnit {
    return DurationUnitFromJSONTyped(json, false);
}

export function DurationUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): DurationUnit {
    return json as DurationUnit;
}

export function DurationUnitToJSON(value?: DurationUnit | null): any {
    return value as any;
}

